import { render, staticRenderFns } from "./MidtransIntegration.vue?vue&type=template&id=6ebad042&"
import script from "./MidtransIntegration.vue?vue&type=script&lang=js&"
export * from "./MidtransIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports